import React, { useEffect, useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

function Login({ setUser, setIsLogin }) {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({ ...prev, [name]: value }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validate = () => {
        let newErrors = {};
        if (!credentials.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(credentials.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!credentials.password.trim()) {
            newErrors.password = "Password is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setIsLoading(true);

        try {
            const response = await axios.post(`${SERVER_URL}/login`, credentials, { withCredentials: true });
            console.log("response status: ", response.status, "response data: ", response.data)
            if (response.status === 200) {
                const userData = response.data.user;
                // Update state first
                setUser(userData);
                setIsLogin(true);

                // Then navigate based on role
                if (userData.is_admin) {
                    navigate('/admin');
                } else {
                    navigate('/');
                }
            }
        } catch (error) {
            console.error("Login Error:", error.response?.data?.detail?.message);
            if (error.response?.status === 401) {
                const field = error.response?.data?.detail?.field;
                setErrors(prev => ({ ...prev, [field]: error.response?.data?.detail?.message }));
                setUser(null);
                setIsLogin(false);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="app-container my-5">
            <div className="card">
                <div className="text-center mb-4">
                    <h2 className="text-primary mb-2">Sign In</h2>
                    {/* <p className="text-secondary">Login to access your dashboard</p> */}
                </div>

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3 text-start" controlId="email">
                        <Form.Label className="form-label">Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter Email"
                            name="email"
                            value={credentials.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            className="form-control"
                        />
                        <Form.Control.Feedback type="invalid" className="text-error">
                            {errors.email}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3 text-start" controlId="password">
                        <Form.Label className="form-label">Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Enter Password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            isInvalid={!!errors.password}
                            className="form-control"
                        />
                        <Form.Control.Feedback type="invalid" className="text-error">
                            {errors.password}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Button variant="primary" type="submit" className="btn btn-primary mt-3" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Logging In...</span>
                            </>
                        ) : (
                            "Login"
                        )}
                    </Button>
                </Form>

                <div className="text-center mt-3">
                    <p className="text-secondary">
                        Don't have an account? <Link to="/sign-up" className="text-custom fw-bold text-decoration-none">Sign Up</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Login;